export default __webpack_public_path__ + "static/media/ScratchJr.d004c2e2.png";